export const GITHUB_REQUEST_PROCESSING_REQ = 'GITHUB_REQUEST_PROCESSING_REQ';
export const GITHUB_REQUEST_PROCESSING_OK = 'GITHUB_REQUEST_PROCESSING_OK';
export const GITHUB_REQUEST_PROCESSING_ERR = 'GITHUB_REQUEST_PROCESSING_ERR';

export const GET_GITHUB_PROJECT_SETTINGS_REQ = 'GET_GITHUB_PROJECT_SETTINGS_REQ';
export const GET_GITHUB_PROJECT_SETTINGS_OK = 'GET_GITHUB_PROJECT_SETTINGS_OK';

export const SHOW_ADD_GITHUB_REPO_URL_POPUP = 'SHOW_ADD_GITHUB_REPO_URL_POPUP';
export const CLOSE_ADD_GITHUB_REPO_URL_POPUP = 'CLOSE_ADD_GITHUB_REPO_URL_POPUP';

export const SAVE_GITHUB_PROJECT_SETTINGS_REQ = 'SAVE_GITHUB_PROJECT_SETTINGS_REQ';
export const SAVE_GITHUB_PROJECT_SETTINGS_OK = 'SAVE_GITHUB_PROJECT_SETTINGS_OK';

export const REMOVE_GITHUB_PROJECT_SETTINGS_REQ = 'REMOVE_GITHUB_PROJECT_SETTINGS_REQ';
export const REMOVE_GITHUB_PROJECT_SETTINGS_OK = 'REMOVE_GITHUB_PROJECT_SETTINGS_OK';

export const PULL_PROJECT_FROM_GITHUB_REQ = 'PULL_PROJECT_FROM_GITHUB_REQ';
export const PULL_PROJECT_FROM_GITHUB_OK = 'PULL_PROJECT_FROM_GITHUB_OK';
export const PULL_PROJECT_FROM_GITHUB_ERR = 'PULL_PROJECT_FROM_GITHUB_ERR';

export const PUSH_PROJECT_TO_GITHUB_REQ = 'PUSH_PROJECT_TO_GITHUB_REQ';
export const PUSH_PROJECT_TO_GITHUB_OK = 'PUSH_PROJECT_TO_GITHUB_OK';
export const PUSH_PROJECT_TO_GITHUB_ERR = 'PUSH_PROJECT_TO_GITHUB_ERR';

export const CHECK_PUSH_STATUS_BEFORE_PUSH_REQ = 'CHECK_PUSH_STATUS_BEFORE_PUSH_REQ';
export const CHECK_PUSH_STATUS_BEFORE_PUSH_OK = 'CHECK_PUSH_STATUS_BEFORE_PUSH_OK';

export const CHECK_CHANGES_TO_PULL_FROM_GITHUB_REQ = 'CHECK_CHANGES_TO_PULL_FROM_GITHUB_REQ';
export const CHECK_CHANGES_TO_PULL_FROM_GITHUB_OK = 'CHECK_CHANGES_TO_PULL_FROM_GITHUB_OK';

export const CHECK_CHANGES_TO_PUSH_TO_GITHUB_REQ = 'CHECK_CHANGES_TO_PUSH_TO_GITHUB_REQ';
export const CHECK_CHANGES_TO_PUSH_TO_GITHUB_OK = 'CHECK_CHANGES_TO_PUSH_TO_GITHUB_OK';

export const CHECK_FOR_UNSAVED_CHANGES_IN_PROJECT_FOR_GITHUB_REQ = 'CHECK_FOR_UNSAVED_CHANGES_IN_PROJECT_FOR_GITHUB_REQ';

export const GET_REMOTE_FILES_REQ = 'GET_REMOTE_FILES_REQ';
export const GET_REMOTE_FILES_OK = 'GET_REMOTE_FILES_OK';

export const RESET_GITHUB_PROJECT_DATA_REQ = 'RESET_GITHUB_PROJECT_DATA_REQ';

export const GITHUB_CREDENTIALS_ERR = 'GITHUB_CREDENTIALS_ERR';

export const GET_ORGANIZATIONS_BY_USER_REQ = 'GET_ORGANIZATIONS_BY_USER_REQ';
export const GET_ORGANIZATIONS_BY_USER_OK = 'GET_ORGANIZATIONS_BY_USER_OK';

export const GET_REPOSITORIES_BY_USER_REQ = 'GET_REPOSITORIES_BY_USER_REQ';
export const GET_REPOSITORIES_BY_USER_OK = 'GET_REPOSITORIES_BY_USER_OK';

export const GET_BRANCHES_BY_REPOSITORY_REQ = 'GET_BRANCHES_BY_REPOSITORY_REQ';
export const GET_BRANCHES_BY_REPOSITORY_OK = 'GET_BRANCHES_BY_REPOSITORY_OK';

export const GET_FILES_BY_BRANCH_REQ = 'GET_FILES_BY_BRANCH_REQ';
export const GET_FILES_BY_BRANCH_OK = 'GET_FILES_BY_BRANCH_OK';

export const RESET_BRANCH_AND_FILES_AFTER_SWITCHING_REPO_REQ = 'RESET_BRANCH_AND_FILES_AFTER_SWITCHING_REPO_REQ';
export const RESET_BRANCH_AND_FILES_AFTER_SWITCHING_REPO_OK = 'RESET_BRANCH_AND_FILES_AFTER_SWITCHING_REPO_OK';

export const ADD_REPO_WITHOUT_FILES_TO_PROJECT_REQ = 'ADD_REPO_WITHOUT_FILES_TO_PROJECT_REQ';

export const ADD_FILES_TO_PROJECT_REQ = 'ADD_FILES_TO_PROJECT_REQ';
export const ADD_FILES_TO_PROJECT_OK = 'ADD_FILES_TO_PROJECT_OK';

export const ADD_REPO_FOR_CI_CD_REQ = 'ADD_REPO_FOR_CI_CD_REQ';
export const ADD_REPO_FOR_CI_CD_OK = 'ADD_REPO_FOR_CI_CD_OK';

export const GET_SCRIPTS_FOR_CI_CD_REQ = 'GET_SCRIPTS_FOR_CI_CD_REQ';
export const GET_SCRIPTS_FOR_CI_CD_OK = 'GET_SCRIPTS_FOR_CI_CD_OK';

export const PULL_TEST_CASES_REQ = 'PULL_TEST_CASES_REQ';
export const PULL_TEST_CASES_OK = 'PULL_TEST_CASES_OK';

export const PUSH_TEST_CASES_REQ = 'PUSH_TEST_CASES_REQ';
export const PUSH_TEST_CASES_OK = 'PUSH_TEST_CASES_OK';

export const REVOKE_GITHUB_ACCESS_REQ = 'REVOKE_GITHUB_ACCESS_REQ';
export const REVOKE_GITHUB_ACCESS_OK = 'REVOKE_GITHUB_ACCESS_OK';